// extracted by mini-css-extract-plugin
export default {"error_boundary":"Hooks_error_boundary__JFw29","error_boundary_dark":"Hooks_error_boundary_dark__zRVSR"};